var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-table",
        { attrs: { data: _vm.pagingList, border: "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60" }
          }),
          _c("el-table-column", { attrs: { prop: "flag", label: "flag" } }),
          _c("el-table-column", {
            attrs: { prop: "language", label: "语言" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " + _vm._s(row.language == "zh" ? "中文" : "英文") + " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "desc", label: "desc" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: { effect: "dark", placement: "top" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tooltip",
                            attrs: { slot: "content" },
                            slot: "content"
                          },
                          [_vm._v(_vm._s(row.desc))]
                        ),
                        _c("div", { staticClass: "text-ellipsis-3" }, [
                          _vm._v(_vm._s(row.desc))
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "操作", width: "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: {
                          click: function($event) {
                            _vm.$refs[row.flag].init(row)
                          }
                        }
                      },
                      [_vm._v("修改")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("copyright", { ref: "copyright", on: { change: _vm.getList } }),
      _c("about", { ref: "about", on: { change: _vm.getList } }),
      _c("history", { ref: "history", on: { change: _vm.getList } }),
      _c("honor", { ref: "honor", on: { change: _vm.getList } }),
      _c("information", { ref: "information", on: { change: _vm.getList } }),
      _c("logo", { ref: "logo", on: { change: _vm.getList } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }